/* eslint-disable max-len */
/**
 * Key down handler for RadioButton components. Uses query selector and
 * handleAvailableValuesValueChange to navigate based on the cursor key pressed
 *
 */

const handleMoveDown = (selectedElementIndex, availableValues) => (selectedElementIndex + 1) % availableValues.length;

const handleMoveUp = (selectedElementIndex, availableValues) => {
    return selectedElementIndex === 0 ? availableValues.length - 1 : (selectedElementIndex - 1) % availableValues.length;
};

const eventMap = {
    SPACE_BAR: () => -1,
    ArrowDown: handleMoveDown,
    ArrowRight: handleMoveDown,
    ArrowUp: handleMoveUp,
    ArrowLeft: handleMoveUp,
};

export default {
    makeHandleRadioButtonKeyDown: (focusTrigger, selectedValue) => (
        evt,
        props,
        handleAvailableValuesValueChange
    ) => {
        const {
            model,
            path,
            availableValues
        } = props;

        // ML: getDataTypeAwareSelectedValue to match the radio button
        const selectedElementIndex = availableValues.findIndex(
            (el) => el.code === selectedValue
        );

        // eslint-disable-next-line no-use-before-define
        const handleMove = eventMap[evt.key];
        if (handleMove) {
            evt.preventDefault();
        }
        const targetIndex = handleMove
            ? handleMove(selectedElementIndex, availableValues)
            : -1;

        const selectedValueCode = availableValues[targetIndex].code;
        if (targetIndex >= 0) {
            handleAvailableValuesValueChange(
                selectedValueCode,
                model || path
            );
            // eslint-disable-next-line no-unused-expressions
            focusTrigger
                && focusTrigger(evt.currentTarget, selectedValueCode);
        }
    },


    getTabIndex: (index) => (index === 0 ? 0 : -1)
};
